import { Text } from '@foss/legion-ui'
import { CodeBlock } from '../content/CodeBlock'
import { Workspace } from '../workspace/Workspace'
import { HOOKS } from '../content/hooks'
import prose from '../content/Prose.module.css'

export function HookPage({ slug }: { slug: string }) {
  const hook = HOOKS[slug]
  if (!hook) {
    return (
      <Text tone="muted" data-testid="not-found">
        No page at this address.
      </Text>
    )
  }

  return (
    <div className={prose.prose} data-testid={`hook-page-${slug}`}>
      <CodeBlock label="import">{hook.importLine}</CodeBlock>

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Signature
        </Text>
        <CodeBlock label="typescript">{hook.signature}</CodeBlock>
        {hook.notes.map((note) => (
          <Text key={note}>{note}</Text>
        ))}
      </section>

      {hook.example && (
        <section className={prose.section}>
          <Text variant="heading" as="h2">
            Example
          </Text>
          <Workspace name={hook.name} source={hook.example} />
        </section>
      )}
    </div>
  )
}
